import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { requestConfig } from "@/services/api"
import type { Config } from "@/types/config"
import type { CompanyInfo } from "@/analytics"

export const useConfigStore = defineStore("config", () => {
  const config = ref<Config | null>(null)

  const companyId = computed(() => (config.value?.company?.companyId != null ? String(config.value.company.companyId) : ""))
  const companyName = computed(() => config.value?.company?.companyName ?? "")

  // The login's name for the sidebar and profile. Logins are shared per company, so this names the
  // account, never the person ordering — that is the form's "Kontaktinformasjon".
  const profileName = computed(() => config.value?.user?.name || config.value?.user?.oneClickBookingName || "")
  const profileEmail = computed(() => config.value?.user?.email ?? "")
  // Receipts are per login: a company can keep them to one user and order through a shared one
  const canSeeReceipt = computed(() => config.value?.user?.canSeeReceipt === true)

  const companyInfo = computed<CompanyInfo | null>(() => (config.value ? { companyId: companyId.value, companyName: companyName.value } : null))

  async function fetchConfig(): Promise<void> {
    try {
      config.value = await requestConfig()
    } catch (error) {
      config.value = null
      throw error
    }
  }

  function clearConfig(): void {
    config.value = null
  }

  return {
    config,
    companyId,
    companyName,
    profileName,
    profileEmail,
    canSeeReceipt,
    companyInfo,
    fetchConfig,
    clearConfig
  }
})
